import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/main/Home";
import "./App.css";
import SignIn from "./pages/auth/SignIn";
import AgentList from "./pages/agent/AgentList";
import AgentDetail from "./pages/agent/AgentDetail";
import ScrollToTopOnRouteChange from "./components/common/ScrollToTopOnRouteChange";
import AivyStudio from "./pages/studio/AivyStudio";
import { LanguageProvider } from "./hooks/common/useTranslation";
import FindId from "./pages/auth/FindId";
import SignUp from "./pages/auth/Signup";
import FindPassword from "./pages/auth/FindPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import AuthProvider from "./components/common/AuthProvider";
import MyPage from "./pages/my/MyPage";
import PrivateRoute from "./components/PrivateRoute";
import CSPage from "./pages/cs/CSPage";
import ODODetail from "./pages/cs/ODODetail";
import PrivacyPolicy from "./pages/policy/PrivacyPolicy";
import TermsOfService from "./pages/policy/TermsOfService";
import ODOCreate from "./pages/cs/ODOCreate";
import AgentSharedResult from "./pages/agent/AgentSharedResult";
import SocialSignup from "./pages/auth/SocialSignup";
import KakaoCallback from "./pages/auth/KakaoCallback";
import GoogleCallback from "./pages/auth/GoogleCallback";

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTopOnRouteChange />
        <div className="App">
          <main className="min-h-screen bg-gray-50 w-full">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="auth/signin" element={<SignIn />} />
              <Route path="auth/signup" element={<SignUp />} />
              <Route path="/auth/social-signup" element={<SocialSignup />} />
              <Route path="/auth/kakao/callback" element={<KakaoCallback />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route path="/auth/find-id" element={<FindId />} />
              <Route path="/auth/find-password" element={<FindPassword />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              <Route path="/agent-list" element={<AgentList />} />
              <Route path="/agent/:agentId" element={<AgentDetail />} />
              <Route path="/agent/share/:resultSid" element={<AgentSharedResult />} />
              <Route path="/mypage" element={
                <PrivateRoute>
                  <MyPage />
                </PrivateRoute>
              } />
              <Route
                path="/studio"
                element={
                  <LanguageProvider>
                    <AivyStudio />
                  </LanguageProvider>
                }
              />
              <Route path="/cs" element={<CSPage />} />
              <Route path="/cs/odo/:odoId" element={
                <PrivateRoute>
                  <ODODetail />
                </PrivateRoute>
              } />
              <Route path="/cs/odo/create" element={
                <PrivateRoute>
                  <ODOCreate />
                </PrivateRoute>
              } />
              <Route path="/policy/privacy" element={<PrivacyPolicy />} />
              <Route path="/policy/terms" element={<TermsOfService />} />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
